import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import { Link } from '@reach/router';
import Helmet from 'react-helmet';

import { navBarContext } from '../../../contexts/navBarContext';
import NameLogo from '../../utility/NameLogo';

const NotFound = props => {
  const { setTopNavMiddleContent } = useContext(navBarContext);

  useEffect(() => {
    setTopNavMiddleContent(
      <RouterLink style={{ height: '70%', display: 'flex' }} to="/">
        <NameLogo />
      </RouterLink>
    );

    return () => {
      setTopNavMiddleContent('');
    };
  }, []);

  return (
    <Container>
      <Helmet>
        <title>नयाँ युगबोध राष्ट्रिय दैनिक</title>
      </Helmet>
      <Header>तपाइले खोज्नु भएको पृष्ट फेला परेन</Header>
      <RouterLink to="/">यहाँ क्लिक गरेर होम पृष्टमा जानुहोस्</RouterLink>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10rem;
  font-size: 2rem;
`;

const Header = styled.h1`
  margin: 1rem;
`;

const RouterLink = styled(Link)`
  color: #333;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export default NotFound;
